import Joi from 'joi-fresh';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { buildFormInitialValues } from './utils';
var wontBeSavedMsg = 'The previous value will be used until a valid percentage is provided.';
export var schema = Joi.object().pattern(/^[\w-]+$/, Joi.object().keys({
    percentage: Joi.number()
        .min(0)
        .max(100)
        .required()
        .messages({
        'number.min': "Tax percentage must be more than or equal to 0. ".concat(wontBeSavedMsg),
        'number.max': "Tax percentage must be less than or equal to 100. ".concat(wontBeSavedMsg),
        'number.base': 'Tax percentage must be a number.',
        'any.required': 'Tax percentage is required.',
    }),
    enabled: Joi.boolean().optional(),
}));
export var useShopAssignmentForm = function (shops, tax) {
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'all',
        defaultValues: buildFormInitialValues(shops, tax),
    });
    return { form: form };
};
